import styled, { css } from 'styled-components';

interface ItemInfoBtn {
    isPointer?: boolean;
}

export const ItemInfoBtn = styled.div<ItemInfoBtn>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    ${props => props.isPointer ? css`cursor: pointer;` : null}
    line-height: 22px;
`;

export const InfoWrapper = styled.div`
    display: flex;
    flex-direction: column;
    text-align: start;

    > label {
        pointer-events: none;
    }

    > label:not(:first-child) {
        margin-top: 4px;
    }
`;